







































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { User } from "../../../domain/user";
import { MultiOrderableSelectableMixin } from "../../system/selectors/mixins";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import MultiOrderableOptionListBoxSelector from "../../system/selectors/MultiOrderableOptionListBoxSelector.vue";
import { UserSelectableMixin } from "./mixins";

@Component({
  components: {
    OptionListBoxSelector,
    MultiOrderableOptionListBoxSelector,
  },
})
export default class MultiOrderableUserListSelector extends Mixins(UserSelectableMixin, MultiOrderableSelectableMixin) {
  @Prop({ default: false })
  isVisible: boolean;

  @Prop({ default: false })
  defaultMultiSelect: boolean;

  @Prop()
  isSwitchable: boolean;

  data(): any {
    return {
      resetting: false,
      modeSelectorValue: false,
      multiSelectMode: false,
      singleEditingSource: null,
    };
  }
  resetting: boolean;
  modeSelectorValue: boolean;
  multiSelectMode: boolean;
  singleEditingSource: User;

  mounted() {
    this.reset();
  }

  get isSelectionCountVisible(): boolean {
    return this.shouldShowSelectionCount && this.multiSelectMode;
  }

  get optionClassName(): string {
    return this.isSwitchable
      ? "is-switchable"
      : "is-un-switchable";
  }

  private async reset(): Promise<void> {
    this.resetting = true;
    this.singleEditingSource = (this.editingSource && this.editingSource.length === 1)
      ? this.editingSource[0]
      : null;
    this.$emit("clicked", this.singleEditingSource);
    this.modeSelectorValue = this.defaultMultiSelect;
    this.onModeSelectorValueUpdated(this.defaultMultiSelect, this.defaultMultiSelect);
    await this.$nextTick();
    const selector = this.$refs.selector as OptionListBoxSelector;
    if (selector) {
      selector.scrollIntoView();
    }
    this.resetting = false;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      this.reset();
    }
  }

  @Watch("modeSelectorValue")
  async onModeSelectorValueUpdated(newValue: boolean, oldValue: boolean): Promise<void> {
    if (!newValue && this.editingSource && this.editingSource.length > 1) {
      if (this.resetting) {
        this.modeSelectorValue = true;
        return;
      }
      const index = await this.$commonDialogs.confirmation.confirmDestructCancel(
        "確認",
        ["選択中の内容を破棄しますが、よろしいですか？"]
      );
      if (index === 0) {
        this.editingSource = [];
        this.multiSelectMode = false;
      } else {
        this.modeSelectorValue = true;
      }
      return;
    }
    this.multiSelectMode = newValue;
  }

  @Watch("singleEditingSource")
  onSingleEditingSourceUpdated(newValue: User, oldValue: User): void {
    if (newValue) {
      this.editingSource = [newValue];
      this.$emit("clicked", newValue);
    } else if (!this.multiSelectMode) {
      this.editingSource = [];
    }
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: User[], oldValue: User[]): void {
    if (newValue && newValue.length === 1) {
      this.singleEditingSource = newValue[0];
    } else if (this.multiSelectMode) {
      this.singleEditingSource = null;
    }
  }

  @Emit()
  clicked(clicked: User): void {}

  @Emit()
  dblclick(e: PointerEvent): void {}
}
